import { DashVideo } from '../../media/dash-video';
import { safeDefine } from '../../registration/safe-define';

/** MPEG-DASH media element powered by dash.js and registered as `<dash-video>`. */
export class DashVideoElement extends DashVideo {
  static readonly tagName = 'dash-video';
}

safeDefine(DashVideoElement);

declare global {
  interface HTMLElementTagNameMap {
    [DashVideoElement.tagName]: DashVideoElement;
  }
}
